import React from "react";
import { Clock, MonitorPlay, MoonStars, ShieldCheck } from "@phosphor-icons/react";

const PROMISES = [
  {
    icon: Clock,
    title: "Response within 15 minutes",
    sub: "Mon–Sat, 8 AM – 8 PM (business hours)",
  },
  {
    icon: MonitorPlay,
    title: "Same-day remote support",
    sub: "Most software issues solved in one session",
  },
  {
    icon: MoonStars,
    title: "Emergency after-hours support",
    sub: "Available for active business clients",
  },
];

export default function ResponsePromise() {
  return (
    <section
      data-testid="response-promise-section"
      className="bg-zinc-950 text-white py-16 md:py-20 relative overflow-hidden"
    >
      <div className="absolute inset-0 hero-grid opacity-40" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-blue-600/15 border border-blue-500/30 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-blue-300">
            <ShieldCheck size={13} weight="fill" /> Our commitment
          </div>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter text-white">
            Response times you can count on.
          </h2>
          <p className="mt-4 text-zinc-300 text-[15px]">
            These aren&rsquo;t aspirations — they&rsquo;re commitments. Hold us to them.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-3 gap-4">
          {PROMISES.map(({ icon: Icon, title, sub }, i) => (
            <div
              key={title}
              data-testid={`promise-${i}`}
              className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 hover:bg-white/[0.07] transition-colors"
            >
              <div className="h-11 w-11 rounded-xl bg-blue-600/25 text-blue-300 grid place-items-center">
                <Icon size={22} weight="duotone" />
              </div>
              <h3 className="mt-5 font-heading text-lg font-semibold text-white">{title}</h3>
              <p className="mt-1.5 text-sm text-zinc-400 leading-snug">{sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
